import Conversation from 'messaging/models/Conversation'
import { Id } from '../types/definitions'

const link = {
  welcome: () => `/`,
  logout: (url?: string) => `/logout${url ? '?redirect_to=' + url : ''}`,
  opportunities: () => `/opportunities`,
  opportunity: (opportunityId: string) => `/opportunities/${opportunityId}`,
  workspaceOpportunities: () => `/opportunities/workspaces`,
  jobs: () => `/jobs`,
  job: (jobId: string) => `/jobs/${jobId}`,
  checkout: (jobId: string) => `/jobs/${jobId}/checkout`,
  mobileJob: (jobId: string) => `/mobile/jobs/${jobId}`,
  documents: () => `/documents`,
  proPayouts: () => '/payouts',
  documentsManagement: () => `/documents-management`,
  teams: () => `/teams`,
  team: (teamSlug?: string) => `/teams${teamSlug ? `/${teamSlug}` : ''}`,
  admin: () => `/admin`,
  adminChangeRequests: () => `/admin/change-requests`,
  adminServiceManager: () => `/admin/service-manager`,
  adminBundleManager: () => `/admin/bundle-manager`,
  adminStaffingManager: () => `/admin/staffing-manager`,
  adminPayouts: () => `/admin/payouts`,
  adminBookkeepingManager: () => `/admin/bookkeeping-manager`,
  adminPayoutsReview: () => `/admin/payouts/review`,
  adminAccountMergeRequests: () => `/admin/merge-requests`,
  adminPayoutsFollowUp: () => `/admin/payouts/follow-up`,
  adminPayoutsTransactions: () => `/admin/payouts/transactions`,
  profile: () => `/profile`,
  profileGeneral: () => `/profile/general`,
  profileBilling: () => `/profile/billing`,
  profileBillingPaymentMethods: () => `/profile/billing/payment-methods`,
  profileBillingPayoutMethod: () => `/profile/billing/payout-method`,
  profileNotifications: () => `/profile/notifications`,
  profileSettings: () => `/profile/settings`,
  editDraftJob: (id: string) => `/new/${id}`,
  conversation: (conversation: Conversation) => {
    if (conversation.meta.type === 'Job') {
      const jobId = conversation.meta.id
      return link.job(jobId)
    }
    console.warn('Tried to navigate to a conversation not in Job somehow')
    return link.welcome()
  },
  firmDashboard: () => '/dashboard',
  scopingJobs: () => '/scoping-jobs',
  scopingJob: (scopingId: Id) => `/scoping-jobs/${scopingId}`,
  userManagement: () => `/users`,
  userDetails: (userPublicId: string) => `/users/${userPublicId}`,
  clientUserManagement: () => `/clients`,
  clientUserDetails: (userPublicId: string) => `/clients/${userPublicId}`,
  callCenter: () => `/call-center`,
  callCenterJob: (jobId: string) => `/call-center/${jobId}`,
  callCenterJobCheckout: (jobId: Id) => `/call-center/${jobId}/checkout`,
}

export default link
